import { tv } from "tailwind-variants";
import { cn } from "../../utils/class-names";
import { Button, getButtonClassNames } from "../button";

export const disconnectedTrigger = tv({
  base: cn(
    getButtonClassNames("primary", "normal"),
    "sm:w-fit flex items-center gap-2.5"
  ),
});

interface DisconnectedTriggerProps {
  className?: string;
  onClick: () => void;
}

export function DisconnectedTrigger({
  className,
  onClick,
}: DisconnectedTriggerProps): JSX.Element {
  return (
    <Button
      onClick={onClick}
      variant="primary"
      className={disconnectedTrigger({ className })}
      data-cy="wallet-info-button"
    >
      <DisconnectedTriggerContent />
    </Button>
  );
}

interface DisconnectedTriggerContentProps {
  className?: string;
}

export function DisconnectedTriggerContent({
  className,
}: DisconnectedTriggerContentProps): JSX.Element {
  return <div className={className}>Connect wallet</div>;
}
